<div class="container">  
     <div *ngIf="effectivePeriods.length > 0">
          <div *ngFor="let period of effectivePeriods">
               <div class="row">
                    <div class="column-name">
                         <div>{{period.name}}</div>
                    </div>
                    <div class="column-date">
                         <div>{{convertDate(period.start)}}</div>
                    </div>
                    <div [style]="{
                         'font-style': 'italic', 
                         'color': 'var(--text-description)',
                         'font-size': '$text-sm'
                         }">
                         <div>to</div>
                    </div>
                    <div class="column-date">
                         <div>{{convertDate(period.end)}}</div>
                    </div>

               </div>

          </div>
     </div>
</div>
